import React, { useEffect, useState } from "react";
import { authSVC } from "../../services";
import moment from "moment";
import { useB2BContext } from "../../context/ContextB2B";
import { Image, Typography } from "antd";

import * as echarts from "echarts";
import OverviewCustom from "./OverviewCustom";
import "./Overview.scss";
import OverallResultAd from "./overallResultAd";
import Deptgrid from "./deptgrid";
import BarChartOverviewAd from "./BarChartad";
import { AppModal } from "../../components/common";

const { Text } = Typography;

function Overview() {
  const [overallLevel, setoverallLevel] = useState<any>(null);
  const { getUserByID } = useB2BContext();
  const [isLoading, setIsLoding] = useState(true);
  const [isPaymentApproved, setIsPaymentApproved] = useState(false);

  const handlePaymentApproved = () => setIsPaymentApproved(true);
  const handleCancelPaymentApproved = () => setIsPaymentApproved(false);

  useEffect(() => {
    if (isLoading) return;
    const chartElement = document.getElementById(
      "workforce-productivity-chart",
    ) as HTMLDivElement | null;
    if (!chartElement) return;
    const chart =
      echarts.getInstanceByDom(chartElement) || echarts.init(chartElement);
    const option = {
      backgroundColor: "#ffffff",
      grid: {
        top: 30,
        left: 0,
        right: 10,
        bottom: 5,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 8,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: "#a6a8c6" },
        splitLine: { lineStyle: { color: "#e6e9f7" } },
      },
      series: [
        {
          type: "line",
          smooth: true,
          showSymbol: false,
          data: [
            2.5,
            2.5,
            3,
            3.4,
            5.1,
            6.9,
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          lineStyle: { width: 1, color: "#b21e49" },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(226,0,137,0.63)" },
              { offset: 1, color: "rgba(226,0,137,0.02)" },
            ]),
          },
        },
      ],
    };
    chart.setOption(option, true);
    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);
    setTimeout(handleResize, 0);
    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) return;
    const chartElement = document.getElementById(
      "workforce-eng-chart",
    ) as HTMLDivElement | null;
    if (!chartElement) return;
    const chart =
      echarts.getInstanceByDom(chartElement) || echarts.init(chartElement);
    const option = {
      backgroundColor: "#ffffff",
      grid: {
        top: 30,
        left: 0,
        right: 10,
        bottom: 5,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 8,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: "#a6a8c6" },
        splitLine: { lineStyle: { color: "#e6e9f7" } },
      },
      markLine: undefined,
      series: [
        {
          type: "line",
          smooth: true,
          showSymbol: false,
          data: [
            2.5,
            2.5,
            3,
            3.4,
            3.7,
            6.8,
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          lineStyle: { width: 1, color: "#F87A35" },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(248,122,53,0.63)" },
              { offset: 1, color: "rgba(248,122,53,0.02)" },
            ]),
          },
        },
      ],
    };
    chart.setOption(option, true);
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) return;
    const chartElement = document.getElementById(
      "month-month-chart",
    ) as HTMLDivElement | null;
    if (!chartElement) return;
    const chart =
      echarts.getInstanceByDom(chartElement) || echarts.init(chartElement);
    const option = {
      backgroundColor: "#ffffff",
      grid: {
        top: 30,
        left: 0,
        right: 10,
        bottom: 5,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 8,
        interval: 1,
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: "#eaedf5", width: 1 } },
      },
      series: [
        {
          type: "line",
          smooth: true,
          showSymbol: false,
          data: [6, 5.5, 5, 4.5, 4, 2.5, null, null, null, null, null, null],
          lineStyle: { width: 1, color: "#5bbcb0" },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(78,162,166,0.63)" },
              { offset: 1, color: "rgba(78,162,166,0.02)" },
            ]),
          },
        },
      ],
    };
    chart.setOption(option, true);
    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);
    setTimeout(handleResize, 0);
    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) return;
    const chartElement = document.getElementById(
      "month-well-chart",
    ) as HTMLDivElement | null;
    if (!chartElement) return;
    const chart =
      echarts.getInstanceByDom(chartElement) || echarts.init(chartElement);
    const option = {
      backgroundColor: "#ffffff",
      grid: {
        top: 30,
        left: 0,
        right: 10,
        bottom: 5,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 8,
        interval: 1,
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: "#eaedf5", width: 1 } },
      },
      series: [
        {
          type: "line",
          smooth: true,
          showSymbol: false,
         data: [1.2, 2, 2.5, 3, 4, 5, null, null, null, null, null, null],
          lineStyle: { width: 1, color: "#5bbcb0" },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(158,198,87,0.63)" },
              { offset: 1, color: "rgba(158,198,87,0.02)" },
            ]),
          },
        },
      ],
    };
    chart.setOption(option, true);
    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);
    setTimeout(handleResize, 0);
    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) return;
    const chartElement = document.getElementById(
      "month-happy-chart",
    ) as HTMLDivElement | null;
    if (!chartElement) return;
    const chart =
      echarts.getInstanceByDom(chartElement) || echarts.init(chartElement);
    const option = {
      backgroundColor: "#ffffff",
      grid: {
        top: 30,
        left: 0,
        right: 10,
        bottom: 5,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 8,
        interval: 1,
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: "#eaedf5", width: 1 } },
      },
      series: [
        {
          type: "line",
          smooth: true,
          showSymbol: false,
          data: [3, 4, 4.5, 5, 5.5, 6,null, null, null, null, null, null],
          lineStyle: { width: 1, color: "#F6EF56" },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(246,239,86,0.63)" },
              { offset: 1, color: "rgba(246,239,86,0.02)" },
            ]),
          },
        },
      ],
    };
    chart.setOption(option, true);
    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);
    setTimeout(handleResize, 0);
    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) return;
    const chartElement = document.getElementById(
      "workforce-abs-chart",
    ) as HTMLDivElement | null;
    if (!chartElement) return;
    const chart =
      echarts.getInstanceByDom(chartElement) || echarts.init(chartElement);
    const option = {
      backgroundColor: "#ffffff",
      grid: {
        top: 30,
        left: 0,
        right: 10,
        bottom: 5,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 8,
        interval: 1,
        axisLabel: { color: "#a0a8d0", fontSize: 12 },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: "#e8eaf3", width: 1 } },
      },
      series: [
        {
          type: "line",
          smooth: false,
          showSymbol: false,
         data: [5, 4.5, 4, 3, 2.5, 2, null, null, null, null, null, null],
          lineStyle: { width: 1, color: "#e8b84b" },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(235,185,71,0.63)" },
              { offset: 1, color: "rgba(235,185,71,0.02)" },
            ]),
          },
        },
      ],
    };
    chart.setOption(option, true);
    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);
    setTimeout(handleResize, 0);
    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [isLoading]);

  useEffect(() => {
    const month: any = moment().format("M");
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .getoverAllViewLevels(getUserByID?.company, month, year)
        .then((res) => {
          setoverallLevel(res?.data?.data[0]);
          console.log(res?.data?.data[0], "res?.data?.data[0]");
          setIsLoding(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  useEffect(() => {
    console.log(getUserByID, "find user type ");
    if (
      getUserByID?.is_payment === true &&
      getUserByID?.first_welcome_message === false
    ) {
      setIsPaymentApproved(true);
      authSVC
        .setFirstWelcomeMessage({ user_id: getUserByID?._id })
        .then((res) => {
          console.log("is first true");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  console.log(getUserByID, "getUserByID");
  const isDemo = JSON.parse(localStorage.getItem("Demo_check") ?? "false");

  // ── Chart card config ──────────────────────────────────────────────────────

  return (
    <>
      {isDemo ? (
        <div className="overview-page">
          {!isLoading ? (
            <>
              <div className="overview-page__grid">
                <div className="overview-col">
                  <OverallResultAd overallLevel={overallLevel} />

                  <div className="overview-card overview-card--reco">
                    <div className="overview-card__reco-header">
                      <h2 className="overview-card__reco-title">
                        Recommendations
                      </h2>
                      <p className="overview-card__reco-sub">
                        Enhanced Wellness, Happiness, and Engagement
                      </p>
                    </div>
                    <div className="overview-card__reco-scroll">
                      {[
                        {
                          num: "01",
                          title: "From Platform",
                          body: `<b>Sales Department</b>: The Intelligence Engine has activated a targeted ImmersiveCARE pathway for the Sales team. Team members will receive guided access to the Stress Reset and Emotional Recalibration modules over the next 14 days. Live chat and counselor availability windows are available for this group. Anonymous micro-pulse check-ins have been triggered to capture real-time sentiment shifts, providing the dashboard with weekly sub-indices instead of monthly snapshots during this critical window. A Manager Enablement Brief has been pushed to your dashboard with stay-conversation frameworks, early warning markers, and workload audit prompts drawn directly from this month's data.`,
                          body1: `Overall Team — Sustaining Positive Growth: Teams showing upward trends (Engineering, Operations, HR, Marketing) will have consistent access to ImmersiveCARE Wellness Maintenance modules. Community forum engagement prompts and guided self-help content will be refreshed with themes aligned to this month's psychometric patterns across the organization.`,
                          body2: "",
                        },
                        {
                          num: "02",
                          title: "Wellness Sessions",
                          body: `<b>Online — Wellness Webinar (60 minutes, virtual)</b> A themed wellness webinar is recommended as an organization-wide touchpoint this month. Topic suggestion based on current data patterns: "Staying Sharp Without Burning Out — Sustaining Performance in High-Pressure Roles." This session will be hosted by the SOULSARA Wellness Team and is designed to normalize wellness conversations across departments while reinforcing the gains showing up in this month's indices.`,
                          body1: `For the Sales department specifically, a facilitator-led half-day intervention is strongly recommended. This is a structured, high-touch session covering team resilience, cohesion rebuilding, and psychological safety activation. The session includes a manager coaching component with practical tools for recognizing disengagement signals and conducting effective stay conversations. Onsite delivery is recommended for this particular intervention as the data patterns suggest interpersonal and environmental factors that are best addressed in a shared physical space. Virtual delivery is available but the SOULSARA Wellness Team's assessment is that onsite will yield stronger outcomes given the nature of the flags.`,
                          body2: `<b> Facilitator-Led — Half Day Program (onsite/online, onsite recommended) </b>Available as an add-on`,
                        },
                        {
                          num: "03",
                          title: "Strategic",
                          body: `The two-month trajectory in Sales points to an emerging structural pattern rather than a momentary dip. The SOULSARA Wellness Team recommends a 45-minute Executive Wellness Briefing with leadership to walk through the Sales data in context. This briefing will cover contributing factors that the psychometric data is surfacing (target pressure cycles, role clarity gaps, team dynamic shifts), explore policy-level interventions such as workload redistribution and recognition cadence changes, and include a projected cost-of-attrition analysis if current trends continue unaddressed. This is where the dashboard data translates into boardroom-level decision making.`,
                          body1: "",
                          body2: "",
                        },
                        {
                          num: "04",
                          title: "Overall Team",
                          body: ` The organization is trending positively on five of six core indices. To lock in these gains and build on them, the following are recommended for the upcoming cycle: a quarterly Wellness Wins session (virtual, org-wide) to acknowledge progress and share anonymized success patterns across departments; continued ImmersiveCARE maintenance pathways for all teams; and a refresh of the Wellness Profile assessment at the 90-day mark to capture shifts and recalibrate individual pathways. The Sales intervention outcomes will be tracked separately and reported in next month's summary to measure impact and adjust course if needed.

`,

                          body1: "",
                          body2: "",
                        },
                      ].map((rec) => (
                        <div key={rec.num} className="overview-card__reco-item">
                          <span className="overview-card__reco-num">
                            {rec.num}
                          </span>

                          <div>
                            <h3 className="overview-card__reco-item-title">
                              {rec.title}
                            </h3>

                            <p
                              className="overview-card__reco-item-body"
                              dangerouslySetInnerHTML={{ __html: rec.body }}
                            />
                            <div
                              className="overview-card__reco-item-body"
                              style={{ margin: "16px 0" }}
                              dangerouslySetInnerHTML={{ __html: rec.body2 }}
                            ></div>
                            <p
                              className="overview-card__reco-item-body"
                              dangerouslySetInnerHTML={{ __html: rec.body1 }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="overview-card">
                    <div className="overview-card__header">
                      <div className="overview-card__title-row">
                        <span
                          className="overview-card__dot"
                          style={{ background: "#9ec657" }}
                        />
                        <h3 className="overview-card__title">Wellness Index</h3>
                        {/* <div className="overview-card__leaf-badge">
                          <img
                            src="/figma/leaf.svg"
                            alt=""
                            width={12}
                            height={12}
                          />
                          <span>
                            <strong>Lower score</strong> = calmer mind
                          </span>
                        </div> */}
                      </div>
                      <div className="overview-card__trend">
                        <Image
                          src="/figma/up_arrow.svg"
                          preview={false}
                          width={14}
                        />
                        <span>86% this year</span>
                      </div>
                    </div>
                    <div
                      id="month-well-chart"
                      className="overview-card__chart"
                    />
                  </div>

                  {/* Happiness chart */}
                  <div className="overview-card">
                    <div className="overview-card__header">
                      <div className="overview-card__title-row">
                        <span
                          className="overview-card__dot"
                          style={{ background: "#F6EF56" }}
                        />
                        <h3 className="overview-card__title">
                          Happiness Index
                        </h3>
                        {/* <div className="overview-card__leaf-badge">
                          <img
                            src="/figma/leaf.svg"
                            alt=""
                            width={12}
                            height={12}
                          />
                          <span>
                            <strong>Lower score</strong> = calmer mind
                          </span>
                        </div> */}
                      </div>
                      <div className="overview-card__trend">
                        <Image
                          src="/figma/up_arrow.svg"
                          preview={false}
                          width={14}
                        />
                        <span>85% this year</span>
                      </div>
                    </div>
                    <div
                      id="month-happy-chart"
                      className="overview-card__chart"
                    />
                  </div>

                  <div className="overview-card overview-card--dept">
                    <Deptgrid />
                  </div>
                </div>

                <div className="overview-col">
                  {/* Productivity chart */}
                  <div className="overview-card">
                    <div className="overview-card__header">
                      <div className="overview-card__title-row">
                        <span
                          className="overview-card__dot"
                          style={{ background: "#b21e49" }}
                        />
                        <h3 className="overview-card__title">
                          Productivity Index
                        </h3>
                      </div>
                      <div className="overview-card__trend">
                        <Image
                          src="/figma/up_arrow.svg"
                          preview={false}
                          width={14}
                        />
                        <span>33% this year</span>
                      </div>
                    </div>
                    <div
                      id="workforce-productivity-chart"
                      className="overview-card__chart"
                    />
                  </div>

                  <div className="overview-card">
                    <div className="overview-card__header">
                      <div className="overview-card__title-row">
                        <span
                          className="overview-card__dot"
                          style={{ background: "#F87A35" }}
                        />
                        <h3 className="overview-card__title">
                          Engagement Index
                        </h3>
                      </div>
                      <div className="overview-card__trend">
                        <Image
                          src="/figma/up_arrow.svg"
                          preview={false}
                          width={14}
                        />
                        <span>89% this year</span>
                      </div>
                    </div>
                    <div
                      id="workforce-eng-chart"
                      className="overview-card__chart"
                    />
                  </div>

                  <BarChartOverviewAd />

                  <div className="overview-card">
                    <div className="overview-card__header">
                      <div className="overview-card__title-row">
                        <span
                          className="overview-card__dot"
                          style={{ background: "#e8b84b" }}
                        />
                        <h3 className="overview-card__title">
                          Absenteeism Index
                        </h3>
                      </div>
                      <div className="overview-card__trend down">
                        <Image
                          src="/figma/down_arrow.svg"
                          preview={false}
                          width={14}
                        />
                        <span>14% this year</span>
                      </div>
                    </div>
                    <div
                      id="workforce-abs-chart"
                      className="overview-card__chart"
                    />
                  </div>

                  <div className="overview-card">
                    <div className="overview-card__header">
                      <div className="overview-card__title-row">
                        <span
                          className="overview-card__dot"
                          style={{ background: "#5bbcb0" }}
                        />
                        <h3 className="overview-card__title">
                          Attrition Index
                        </h3>
                      </div>
                      <div className="overview-card__trend down">
                        <Image
                          src="/figma/down_arrow.svg"
                          preview={false}
                          width={14}
                        />
                        <span>63% this year</span>
                      </div>
                    </div>
                    <div
                      id="month-month-chart"
                      className="overview-card__chart"
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="overview-page__loader">
              <div className="overview-page__spinner">
                <div className="overview-page__spinner-ring" />
                <span>Loading dashboard…</span>
              </div>
            </div>
          )}

          <AppModal
            open={isPaymentApproved}
            onOk={handlePaymentApproved}
            onCancel={handleCancelPaymentApproved}
            className="welcome-modal"
          >
            <div className="welcome-modal__inner">
              <img
                src="/img/Group19356.png"
                alt="Welcome"
                className="welcome-modal__img app-modal__media"
              />
              <div className="welcome-modal__body">
                <div className="welcome-modal__badge">🎉 Payment Approved</div>
                <h2 className="welcome-modal__title">Welcome to SOULSARA</h2>
                <p className="welcome-modal__sub">Your Wellness Community</p>
                <p className="welcome-modal__desc">
                  Thank you for choosing us to support your team's health,
                  happiness, and productivity.
                </p>
                <a href="/departments" className="welcome-modal__cta">
                  Start adding your team now! 🚀
                </a>
                <p className="welcome-modal__help">
                  Need help? We are here for you!{" "}
                  <a
                    href="https://www.soulsara.world/contact-us"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Contact us
                  </a>
                </p>
              </div>
            </div>
          </AppModal>
        </div>
      ) : (
        <OverviewCustom />
      )}
    </>
  );
}

export default Overview;
